/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react'
import { Card, Button, Skeleton } from 'antd'
import { ArrowRightOutlined, CarryOutFilled } from '@ant-design/icons'
import Api from 'api'
import { IoMdArrowRoundBack } from 'react-icons/io'
import { capitalizeFirstLetter, formatAmount } from 'utils'
import { InfiniteScrollContainer, ShareReport } from 'components/elements'
import { config } from 'configs'
import { useHistory } from 'react-router-dom'

const LastYearEarningsReport = () => {
  const history = useHistory()
  const [loading, setLoading] = useState()
  const [report, setReport] = useState()
  const [pdfData, setPdfData] = useState()
  const [selected, setSelected] = useState()

  useEffect(() => {
    setLoading(true)
    Api.get('adminReports/lastYearEarningReport')
      .then((res) => {
        setReport(res.results)
        setPdfData(res.results)
        setLoading(false)
      })
      .catch((error) => {
        console.log('error', error)
        setLoading(false)
      })
  }, [])

  return (
    <Card
      id="LastYearEarningsReport"
      className="mb-24 header-solid list-settings-sessions"
      bordered={false}
      title={[
        <div className="t-flex t-justify-between t-items-center">
          {selected === undefined ? (
            <div className="t-flex t-space-x-4">
              <IoMdArrowRoundBack
                fontSize="1.5rem"
                className="t-cursor-pointer t-min-w-[1.5rem]"
                id="back"
                onClick={() =>
                  history.push('/settings/manage-organization/my-reports')
                }
              />
              <h5 className="font-semibold">Last Year Revenue Report</h5>
            </div>
          ) : (
            <div className="t-flex t-space-x-4">
              <IoMdArrowRoundBack
                fontSize="1.5rem"
                id="back"
                className="t-cursor-pointer t-min-w-[1.5rem]"
                onClick={() => {
                  setPdfData(report)
                  setSelected()
                }}
              />
              <h5 className="font-semibold t-whitespace-normal">
                Last Year Revenue Report -{' '}
                <span className="t-capitalize">{selected}</span>
              </h5>
            </div>
          )}
          {!loading && pdfData != null && (
            <ShareReport
              reportName={
                selected === undefined
                  ? 'Last Year Revenue Report'
                  : `Last Year Revenue Report - ${capitalizeFirstLetter(
                      selected,
                    )}`
              }
              // isSummary is boolean which refect if report is summary report or simple report
              isSummary={selected === undefined}
              report={pdfData}
            />
          )}
        </div>,
      ]}
    >
      {selected === undefined ? (
        <Skeleton loading={loading} paragraph={{ rows: 12 }}>
          {['events', 'campaigns', 'programs', 'services'].map(
            (item, index) => (
              <>
                {index !== 0 && <hr className="gradient-line my-10" />}
                <div className="ant-row-flex ant-row-flex-middle">
                  <div
                    className="text-center ant-col"
                    style={{ minWidth: '40px' }}
                  >
                    <CarryOutFilled
                      className="text-gray-6"
                      style={{ fontSize: '18px' }}
                    />
                  </div>
                  <div className="ant-col pl-15">
                    <p className="mb-0 t-capitalize">{item}</p>
                  </div>
                  <div
                    className="ml-auto ant-col ant-col-12"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <span className="ml-5">
                      {report && report[item]
                        ? formatAmount(report[item])
                        : '$0.00'}
                    </span>
                    <Button
                      type="link"
                      // className={`${
                      //   report &&
                      //   report[item] === 0 &&
                      //   "t-opacity-30 t-cursor-default"
                      // }`}
                      id={`last_year_${item}_see_more`}
                      onClick={() => {
                        setPdfData()
                        setSelected(item)
                      }}
                    >
                      See More <ArrowRightOutlined />
                    </Button>
                  </div>
                </div>
              </>
            ),
          )}
        </Skeleton>
      ) : (
        <Single selected={selected} setPdfData={setPdfData} />
      )}
    </Card>
  )
}

function Single({ selected, setPdfData }) {
  const url = {
    events: 'adminReports/lastEarningReportByEvent',
    campaigns: 'adminReports/lastEarningReportByCampaign',
    programs: 'adminReports/lastEarningReportByProgram',
    services: 'adminReports/lastEarningReportByService',
  }
  const [loading, setLoading] = useState()
  const [report, setReport] = useState()
  const [current, setCurrent] = useState([])

  function compare(a, b) {
    if (a.totalAmount < b.totalAmount) {
      return 1
    }
    if (a.totalAmount > b.totalAmount) {
      return -1
    }
    return 0
  }

  useEffect(() => {
    setLoading(true)
    Api.get(url[selected])
      .then((res) => {
        const data = res.results.Items.sort(compare)
        setReport(data)
        setCurrent(data.slice(0, config.reportItemFirstLoad))
        if (res?.results?.Items && res.results.Items.length > 0) {
          setPdfData(res.results.Items)
        }
        setLoading(false)
      })
      .catch((error) => {
        console.log('error', error)
        setLoading(false)
      })
    // eslint-disable-next-line
  }, [])

  return (
    <Skeleton loading={loading} paragraph={{ rows: 12 }}>
      {report && report.length > 0 ? (
        <InfiniteScrollContainer
          data={report}
          current={current}
          setCurrent={setCurrent}
        >
          <>
            {current.map((item, index) => (
              <>
                {index !== 0 && <hr className="gradient-line my-10" />}
                <div className="ant-row-flex ant-row-flex-middle">
                  <div
                    className="text-center ant-col"
                    style={{ minWidth: '40px' }}
                  >
                    <CarryOutFilled
                      className="text-gray-6"
                      style={{ fontSize: '18px' }}
                    />
                  </div>
                  <div className="ant-col pl-15">
                    <p className="mb-0">{item?.Title}</p>
                    <small className="text-dark">Friday, 12/03/2021</small>
                  </div>
                  <div
                    className="ml-auto ant-col ant-col-24 ant-col-md-12"
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-end',
                    }}
                  >
                    <span className="ml-5">
                      {item?.totalAmount
                        ? formatAmount(item?.totalAmount)
                        : '$0.00'}
                    </span>
                  </div>
                </div>
              </>
            ))}
          </>
        </InfiniteScrollContainer>
      ) : (
        <div>No Data Found</div>
      )}
    </Skeleton>
  )
}

export { LastYearEarningsReport }
